/*
 * @Description: 
 * @Author: ADCannon
 * @Date: 2023-01-10 16:11:16
 * @FilePath: \GamerSky.Valorant\src\assets\config\index.js
 */
let now = new Date();

var apiUrlRoot = "//router2.gamersky.com/@valorant";
// var apiUrlRoot = "//router.gamersky.com/@valorant";
// var apiUrlRoot = "https://localhost:7027";


// 2023年4月18日，开始单机使用：
// // 高峰期时，使用负载均衡：
// if ((now.getHours() == 7 && now.getMinutes() >= 45) ||
//     (now.getHours() == 8 && now.getMinutes() <= 45)) {
//     if (now.getTime() % 2 == 0) {
//         apiUrlRoot = "//router.gamersky.com/@valorant";
//     }
// }


function getCurrentApiRoot()
{
    var GsAppApiUrlRootDefault = "//router.gamersky.com/@";
    var gsAppApiUrlRoot = GsAppApiUrlRootDefault;
    try
    {
        var gsAppApiUrlRoot = GSAppJsApi.Cookie.get("gsAppApiUrlRoot");
        if (gsAppApiUrlRoot != null
        && gsAppApiUrlRoot.length > 0)
        {
            if (gsAppApiUrlRoot.startsWith("http://"))
            {
                gsAppApiUrlRoot = gsAppApiUrlRoot.replace("http://", "//");
            }
            while (gsAppApiUrlRoot.endsWith("/"))
            {
                gsAppApiUrlRoot = gsAppApiUrlRoot.substring(0, gsAppApiUrlRoot.length - 1);
            }
        }
        if (gsAppApiUrlRoot == null
        || gsAppApiUrlRoot.length < 1)
        {
            gsAppApiUrlRoot = GsAppApiUrlRootDefault;
        }
    }
    catch (exception)
    {

        //
        gsAppApiUrlRoot = GsAppApiUrlRootDefault;
    }
    return gsAppApiUrlRoot;
}

const dev = {
    baseUrl: 'https://localhost:7027',
    jsonUrlRoot: 'https://j.gamersky.com/db/valorantSkin/json',
    isApp: true,
    shareUrl: "https://www.gamersky.com/tools/valorantSkin/index.html",
    routerUrl: "//router-test.gamersky.com/@133_8084"
}
const test = {
    baseUrl: '//router-test.gamersky.com/@valorantTracker_7083',
    battleFieldUrl: '//router-test.gamersky.com/@battlefield2042Tracker',
    // baseUrl: apiUrlRoot,
    // baseUrl: '/Valorant',
    jsonUrlRoot: 'https://j.gamersky.com/db/valorantSkin/json',
    isApp: true,
    shareUrl: "https://www.gamersky.com/tools/valorantSkin/index.html",
    routerUrl: getCurrentApiRoot()
}
const prod = {
    // baseUrl: '//gamedb2.gamersky.com/GamerSky.Valorant.Service',
    baseUrl: '//router2.gamersky.com/@valorantTracker',
    deadlockUrl: '//router4.gamersky.com/@deadlockTracker',
    battleFieldUrl: '//router2.gamersky.com/@battlefield2042Tracker',
    jsonUrlRoot: 'https://j.gamersky.com/db/valorantSkin/json',
    isApp: false,
    shareUrl: "https://www.gamersky.com/tools/valorantSkin/index.html",
    routerUrl: getCurrentApiRoot()
}
export default test;
// export default prod;